/**
 * Person Card: scroll-based image swap for mobile
 * On desktop (hover works), CSS handles the swap.
 * On mobile (< 640px), swap images when they scroll into view.
 */

function initPersonCardScrollSwap() {
  const imgs = document.querySelectorAll('.person-card__img');
  imgs.forEach((img) => {
    if (img.complete) {
      img.classList.add('is-loaded');
    } else {
      img.addEventListener(
        'load',
        () => {
          img.classList.add('is-loaded');
        },
        { once: true }
      );
    }
  });

  // Only apply on mobile (matches CSS breakpoint)
  const isMobile = () => window.matchMedia('(max-width: 639px)').matches;

  if (!isMobile()) return;

  const cards = document.querySelectorAll('.person-card__photo');
  if (!cards.length) return;

  // Track if user has scrolled (don't swap on initial load)
  let hasScrolled = false;
  window.addEventListener('scroll', () => { hasScrolled = true; }, { once: true });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const defaultImg = entry.target.querySelector('.person-card__img--default');
        const hoverImg = entry.target.querySelector('.person-card__img--hover');

        if (!defaultImg || !hoverImg) return;

        // Only swap after user has scrolled (prevents initial load swap)
        if (!hasScrolled) return;

        // Require 80% visibility and be in the center 40% of viewport
        if (entry.isIntersecting && entry.intersectionRatio >= 0.8) {
          // Scrolled into view: show funny image
          defaultImg.style.opacity = '0';
          hoverImg.style.opacity = '1';
        } else {
          // Scrolled out: show default image
          defaultImg.style.opacity = '1';
          hoverImg.style.opacity = '0';
        }
      });
    },
    {
      threshold: [0, 0.5, 0.8, 1],
      rootMargin: '-30% 0px -30% 0px', // Only trigger in center 40% of viewport
    }
  );

  cards.forEach((card) => observer.observe(card));

  // Re-check on resize (in case user rotates device)
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (!isMobile()) {
        // Reset to CSS-controlled state on desktop
        cards.forEach((card) => {
          const defaultImg = card.querySelector('.person-card__img--default');
          const hoverImg = card.querySelector('.person-card__img--hover');
          if (defaultImg) defaultImg.style.opacity = '';
          if (hoverImg) hoverImg.style.opacity = '';
        });
        observer.disconnect();
      }
    }, 200);
  });
}

// Run on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPersonCardScrollSwap);
} else {
  initPersonCardScrollSwap();
}
